import { Component, Injectable } from '@angular/core';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class NgxToastrService {

  constructor(private toastr: ToastrService) { }

  success(msg: any, position: any) {
    this.toastr.success( msg, 'Success',  { positionClass: position });
  }
  error(msg: any, position: any) {
    this.toastr.error(msg, 'Error', { positionClass: position });
  }
  warning(msg: any, position: any) {
    this.toastr.warning(msg ,'Warning!' , { positionClass: position });
  }
  info(msg: any, position: any) {
    this.toastr.info( msg,'Info', { positionClass: position });
  }
}
